import { createAction } from "redux-actions";
import { takeLatest, put, select, call, all } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../../utils/queryParams";

export const FETCH_CHART_SUCCESS = "./numberOfActiveMembersBy/FETCH_CHART_SUCCESS";
export const FETCH_CURRENT_USER_SUCCESS = "./numberOfActiveMembersBy/FETCH_CURRENT_USER_SUCCESS";
export const RESET_FILTER_SELECTED = "./numberOfActiveMembersBy/RESET_FILTER_SELECTED";
export const SET_DATES = "./numberOfActiveMembersBy/SET_DATES";
export const SET_FILTERS_DIRTY = "./numberOfActiveMembersBy/SET_FILTERS_DIRTY";
export const SET_LOADING = "./numberOfActiveMembersBy/SET_LOADING";
export const SET_UPDATES_LOADING = "./numberOfActiveMembersBy/SET_UPDATES_LOADING";
export const UPDATE_TABLE_VIEW_SELECTED = "./numberOfActiveMembersBy/UPDATE_TABLE_VIEW_SELECTED";
export const FETCH_CURRENT_USER = "./numberOfActiveMembersBy/FETCH_CURRENT_USER";
export const UPDATE_DATES = "./numberOfActiveMembersBy/UPDATE_DATES";
export const RESET_FILTER = "./numberOfActiveMembersBy/RESET_FILTER";
export const UPDATE_TABLE_VIEW = "./numberOfActiveMembersBy/UPDATE_TABLE_VIEW";
export const UPDATE_CHART = "./numberOfActiveMembersBy/UPDATE_CHART";
export const UPDATE_PERIOD_TYPE = "./numberOfActiveMembersBy/UPDATE_PERIOD_TYPE";
export const UPDATE_CUSTOM_RANGE = "./numberOfActiveMembersBy/UPDATE_CUSTOM_RANGE";
export const FETCH_TOTAL_SUCCESS = "./numberOfActiveMembersBy/FETCH_TOTAL_SUCCESS";
export const FETCH_POS_MODAL_DATA_SUCCESS =
  "./numberOfActiveMembersBy/FETCH_POS_MODAL_DATA_SUCCESS";
export const FETCH_POS_MODAL_DATA = "./numberOfActiveMembersBy/FETCH_POS_MODAL_DATA";
export const FETCH_TABLECHART_SUCCESS = "./numberOfActiveMembersBy/FETCH_TABLECHART_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "./numberOfActiveMembersBy/FETCH_FILTERS_SUCCESS";
export const UPDATE_CATEGORIES = "./numberOfActiveMembersBy/UPDATE_CATEGORIES";
export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateCategories: createAction(UPDATE_CATEGORIES),
  fetchPosModalData: createAction(FETCH_POS_MODAL_DATA)
};
export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(FETCH_POS_MODAL_DATA, fetchPosModalData);
}

const allSagas = [getTotal(), fetchChart(), fetchTableChart()];

export function* fetchCurrentUserData({ payload }) {
  const { filtersUrl } = payload;

  if (filtersUrl) {
    allSagas.unshift(fetchFilters());
  }

  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield setDates();

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: {
        organizationId,
        locationId,
        objectId,
        regionId,
        chartUrl,
        totalUrl,
        posModalUrl,
        tableChartUrl,
        filtersUrl
      },
      selectedRequestDates: { startDate, endDate },
      selectedFilters: { table_view, period_type },
      filtersOptions: { categories, primary_categories, secondary_categories }
    } = state.numberOfActiveMembersBy;
    if (!organizationId && !locationId && !objectId && !regionId && !startDate && !endDate) return;
    const period = period_type.toLowerCase();

    return {
      organization_id: organizationId.toString(),
      location_id: locationId.toString(),
      object_id: objectId.toString(),
      region_id: regionId.toString(),
      startDate,
      endDate,
      table_view,
      period,
      chartUrl,
      totalUrl,
      posModalUrl,
      tableChartUrl,
      filtersUrl,
      categories: filtersUrl ? categories : undefined,
      primary_categories: filtersUrl ? primary_categories : undefined,
      secondary_categories: filtersUrl ? secondary_categories : undefined
    };
  });
}

export function* fetchChart() {
  const {
    organization_id,
    location_id,
    object_id,
    region_id,
    startDate,
    endDate,
    table_view,
    period,
    categories,
    primary_categories,
    secondary_categories,
    chartUrl
  } = yield getCommonApiParams();

  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate,
    table_view,
    period_type: period,
    categories,
    primary_categories,
    secondary_categories
  };
  let url = queryParams.apiVersion + chartUrl;
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_CHART_SUCCESS, payload: data.data });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchTableChart() {
  const {
    organization_id,
    location_id,
    object_id,
    region_id,
    startDate,
    endDate,
    period,
    tableChartUrl,
    categories,
    primary_categories,
    secondary_categories
  } = yield getCommonApiParams();

  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate,
    period_type: period,
    categories,
    primary_categories,
    secondary_categories
  };
  let url = queryParams.apiVersion + tableChartUrl;
  if (tableChartUrl) {
    try {
      let usePost = url.includes("number_of_active_members/");
      let { data } = yield call(
        usePost ? axios.post : axios.get,
        url,
        usePost ? params : { params }
      );
      yield put({ type: FETCH_TABLECHART_SUCCESS, payload: data });
    } catch (err) {
      console.error(err);
    }
  }
}

export function* getTotal() {
  const {
    organization_id,
    location_id,
    object_id,
    region_id,
    startDate,
    endDate,
    totalUrl,
    categories,
    primary_categories,
    secondary_categories
  } = yield getCommonApiParams();

  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate,
    categories,
    primary_categories,
    secondary_categories
  };
  let url = queryParams.apiVersion + totalUrl;
  try {
    let usePost = url.includes("number_of_active_members/");
    let { data } = yield call(usePost ? axios.post : axios.get, url, usePost ? params : { params });
    yield put({
      type: FETCH_TOTAL_SUCCESS,
      payload: { scorecards: data.scorecards, membersCount: data.membersCount }
    });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchFilters() {
  const { organization_id, location_id, object_id, region_id, startDate, endDate, filtersUrl } =
    yield getCommonApiParams();

  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate
  };
  let url = queryParams.apiVersion + filtersUrl;
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: data });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchPosModalData() {
  const { organization_id, location_id, object_id, posModalUrl } = yield getCommonApiParams();
  const params = {
    organization_id,
    location_id,
    object_id
  };
  let url = queryParams.apiVersion + posModalUrl;
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_POS_MODAL_DATA_SUCCESS, payload: data.tableData });
  } catch (err) {
    console.error(err);
  }
}

function* setDates() {
  const endDate = yield select(
    (state) => state.numberOfActiveMembersBy.currentUser.calendarEndDate
  );
  const startDate = moment(endDate).startOf("days").subtract(30, "days").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    const allSaga = [fetchChart(), fetchTableChart(), getTotal()];
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    // yield fetchChart();
    // yield fetchTableChart();
    // yield getTotal();
    yield all(allSaga);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });

  try {
    const allSaga = [fetchChart(), fetchTableChart(), getTotal()];
    yield all(allSaga);
    // yield fetchChart();
    // yield fetchTableChart();
    // yield getTotal();

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  // yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}
